import request from '@/utils/request'


// 查询用户现金券信息列表
export function listVoucher(query) {
  return request({
    url: '/user/voucher/list',
    method: 'get',
    params: query
  })
}

// 查询用户现金券信息分页
export function pageVoucher(query) {
  return request({
    url: '/user/voucher/page',
    method: 'get',
    params: query
  })
}
export function pageRecord(query) {
  return request({
    url: '/user/voucher/record/page',
    method: 'get',
    params: query
  })
}
// 查询用户现金券信息详细
export function getVoucher(data) {
  return request({
    url: '/user/voucher/detail',
    method: 'get',
    params: data
  })
}

// 新增用户现金券信息
export function addVoucher(data) {
  return request({
    url: '/user/voucher/add',
    method: 'post',
    data: data
  })
}

// 修改用户现金券信息
export function updateVoucher(data) {
  return request({
    url: '/user/voucher/edit',
    method: 'post',
    data: data
  })
}
// 修改用户现金券信息
export function sendVoucher(data) {
  return request({
    url: '/user/voucher/send',
    method: 'post',
    data: data
  })
}

// 删除用户现金券信息
export function delVoucher(data) {
  return request({
    url: '/user/voucher/delete',
    method: 'post',
    data: data
  })
}
